import React, {useState} from 'react';



function DoubleClickText({initialText, didSet, color}) { 
    const [isEditing, setIsEditing] = useState(false); 
    const [text, setText] = useState(initialText);

    const handleDoubleClick = () => {setIsEditing(true);}
    const handleBlur = () => {setIsEditing(false);}
    const handleChange = (e) => {setText(e.target.value)}
    const handleKeyDown = (e) => {
        if (e.key === 'Enter'){
            setIsEditing(false);
            didSet(e.target.parentElement.id, e.target.value); 
        }
        else if (e.key === 'Escape') {
            setText(initialText);
            setIsEditing(false);
        }
    }

    return (
        isEditing ? (
            <input type='text' style={{fontSize:12, textAlign:'left', backgroundColor:'grey', color:'white', width:"100%"}} value={text} onBlur={handleBlur} onChange={handleChange} onKeyDown={handleKeyDown}/>
        )
        : (
            <span style={{fontSize:12, textAlign:'left', width:'50%', backgroundColor:color, cursor:'default'}} onDoubleClick={handleDoubleClick}>{text}</span>
        )
    )
}


export default DoubleClickText; 